import React, { FC } from "react";
import { Tag } from "antd";
import { isEmpty, cloneDeep } from "lodash-es";
import ShipmentTagsLib from "../../../../../lib/fulfillment/shipmentTags";

// Libs

/** interfaces */
import { Fulfillment } from "@secondcloset/types";
type ShipmentTag = Fulfillment.ShipmentTag;
type OrderShipmentTag = ShipmentTag | "internal_booking";

interface Props {
  tags: OrderShipmentTag[];
}

const ShipmentTags: FC<Props> = ({ tags }) => {
  if (isEmpty(tags)) return <> - </>;
  return (
    <div className="shipment-tags">
      {ShipmentTagsLib.formatShipmentTags([...tags]).map((tag: { label: string; value: string }, index: number) => {
        const text = ShipmentTagsLib.getShipmentTagText(tag.value);
        const color = ShipmentTagsLib.getShipmentTagColor(tag.value);
        return (
          <Tag color={color} key={text + index}>
            {text}
          </Tag>
        );
      })}
    </div>
  );
};

export default ShipmentTags;
